if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      connectedCallback() {
        this.init(); 
      }

      init() {
        if (this.__initialized) return; 
        this.__initialized = true;

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails || !this.elements.viewer) return;

        this.elements.viewer.addEventListener('slideChanged', (event) => {
           const viewerNode = this.elements.viewer.querySelector(`[data-media-id="${event.detail.currentElement.dataset.mediaId}"]`);
           if (viewerNode) {
               this.setActiveViewer(viewerNode);
           }
        });

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );
        
        this.elements.thumbnails.addEventListener('click', (e) => {
          const tile = e.target.closest('[data-target]');
          if (!tile) return;
          const id = tile.dataset.target;
          this._thumbClick = true;
          this.setActiveMedia(id, false);
          setTimeout(() => { this._thumbClick = false; }, 50);
        });
        
        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches){
          this.removeListSemantic();
        }
      }

      get noAutoScroll() {
        return this.hasAttribute('data-no-autoscroll');
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
        this.setActiveMedia(event.detail.currentElement.dataset.mediaId,false);
      }

      setActiveViewer(singleViewer) {
        if(!window.matchMedia('(min-width: 750px)').matches){
          this.elements.viewer.querySelectorAll('.product__media-item').forEach((element) => element.removeAttribute('aria-current'));
          singleViewer.setAttribute('aria-current', true);
          
          var activeViewrHeight = window.innerWidth;
          
          if(singleViewer.querySelector('.media-type-image .product__media')){
            activeViewrHeight = singleViewer.querySelector('.product__media').offsetHeight || window.innerWidth;
          }
          if(singleViewer.querySelector('.media-type-video deferred-media video')){
            activeViewrHeight = singleViewer.querySelector('deferred-media').offsetHeight || window.innerWidth;
          }
          // this.elements.viewer.querySelector('.product__media-list').style.height = activeViewrHeight + "px";
          // singleViewer.querySelector('.product__media').style.paddingTop = activeViewrHeight + "px";
        }
      }

      setActiveMedia(mediaId, prepend) {
        let activeMedia;
        if(this.mql.matches && this.elements.viewer.querySelector('[data-media-id] img[alt*="1st-"]')){
          activeMedia = this.elements.viewer.querySelector('[data-media-id] img[alt*="1st-"]').closest('[data-media-id]');
        }else{
          activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');
        }
        
        if (!activeMedia) return;

        
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));

        activeMedia.classList.add('is-active');

        if (prepend) {
          
          if(this.elements.viewer.querySelector("img[alt*='1st-']")){
            const first_main_LI = this.elements.viewer.querySelector("img[alt*='1st-']").closest("li");
            const main_UL = first_main_LI.parentNode;
            main_UL.insertBefore(first_main_LI, main_UL.firstElementChild);
          }else{
            if (activeMedia.parentElement.firstChild !== activeMedia) {
              activeMedia.parentElement.prepend(activeMedia);
            }
          }
          
          if (this.elements.thumbnails) {
            let activeThumb;
            if(this.elements.thumbnails.querySelector(`[data-target] img[alt*="1st-"]`)){
              activeThumb = this.elements.thumbnails.querySelector(`[data-target] img[alt*="1st-"]`).closest(`[data-target]`);
            }else{
              activeThumb = this.elements.thumbnails.querySelector( `[data-target="${mediaId}"]`);
            }
            
            if(this.elements.thumbnails.querySelector("img[alt*='1st-']")){
              const first_thumb_LI = this.elements.thumbnails.querySelector("img[alt*='1st-']").closest("li");
              const thumb_UL = first_thumb_LI.parentNode;
              thumb_UL.insertBefore(first_thumb_LI, thumb_UL.firstElementChild);
              setTimeout(() => {
                first_thumb_LI.click();
              },10);
            }else{
              if (activeThumb && activeThumb.parentElement.firstChild !== activeThumb) {
                activeThumb.parentElement.prepend(activeThumb);
              }
            }
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {

          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }

          if (!this.mql.matches || this.noAutoScroll) return;
          
          const rect = activeMedia.getBoundingClientRect();
          if (rect.top <= -0.5) {
            window.scrollTo({
              top: rect.top + window.scrollY,
              behavior: 'instant',
            });
          }
        });

        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {            
          let activeThumb;
          if(this.elements.thumbnails.querySelector(`[data-target="${mediaId}"] img[alt*="1st-"]`)){
            activeThumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"] img[alt*="1st-"]`).closest(`[data-target]`);
          }else{
            activeThumb = this.elements.thumbnails.querySelector( `[data-target="${mediaId}"]`);
          }
          
          if (activeThumb) {
            this.setActiveThumbnail(activeThumb);
            this.announceLiveRegion(
              activeMedia,
              activeThumb.dataset.mediaPosition
            );
          }
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
          
        const btn = thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);

        if (this._thumbClick) return;
        const vimeoIframe = activeItem.querySelector('iframe[src*="vimeo.com"]');
        if (vimeoIframe) {
          let src = vimeoIframe.src;
          
          src = src
          .replace(/autoplay=\d/, "")
          .replace(/loop=\d/, "")
          .replace(/muted=\d/, "")
          .replace(/playsinline=\d/, "");
          
          const params = [
            "autoplay=1",
            "loop=1",
            "muted=1",
            "controls=1",
            "playsinline=1",
            "byline=0",
            "title=0",
          ];
          
          if (src.includes("?")) {
            src = src.split("?")[0] + "?" + params.join("&");
          } else {
            src = src + "?" + params.join("&");
          }
          
          vimeoIframe.src = src;
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}

// CWI CODE N
if(!window.matchMedia('(min-width: 750px)').matches){
  var domReadyViewerHeight = document.querySelector(`[id^="GalleryViewer"] [data-media-id] .product__media`).offsetHeight;
  // document.querySelector('[id^="GalleryViewer"] .product__media-list').style.height = domReadyViewerHeight + "px";
  // document.querySelector('[id^="GalleryViewer"] [data-media-id] .product__media').style.paddingTop = domReadyViewerHeight + "px";
}